// Copy and naming for the on-demand annotated result PDF (#1401), in one place so the two surfaces
// that offer it — the quotations table row menu and the editor's burger menu — can never drift apart.
// Mirrors resultCsv.constants.ts; the PDF build is asynchronous (see resultPdf.helper.ts / the
// quotations hook), which is why this also carries poll timing the CSV flow has no analog for.
export const RESULT_PDF_MESSAGES = {
	menuItem: "Download result PDF",
	pending: "Preparing PDF…",
	// Shown once the build is done and the file itself is transferring — a separate phase from
	// `pending` (#1401 review), since the file can run 100-200MB and the transfer alone can take a
	// while.
	downloading: "Downloading PDF…",
	success: "PDF downloaded",
	// Shown when a save was still travelling when generation started and did not land in time, so the
	// file may be a revision behind. Better than claiming a clean success.
	successMaybeStale: "PDF downloaded, but a recent change may be missing from it.",
	submitted: "This quotation is submitted — its PDF is in the files list.",
	forbidden: "You don't have access to this quotation's PDF.",
	notFound: "This quotation no longer exists.",
	unauthorized: "Your session has expired. Sign in again to download the PDF.",
	failed: "PDF couldn't be generated. Try again.",
	timedOut: "PDF is taking too long. Try again in a moment.",
} as const

// Per-name cap for the composed download name. Two user-entered names plus the joiner have to fit
// inside the ~255-byte limit every common file system enforces, with room for a browser's " (1)"
// de-duplication suffix.
export const RESULT_PDF_NAME_PART_MAX_LENGTH = 80

// How long to let in-flight autosaves finish before generating the PDF. Short: the PDF is worth a
// brief wait, but not a visibly stuck menu.
export const RESULT_PDF_SAVE_FLUSH_TIMEOUT = 5000

// The build endpoint's own docs recommend polling the job every ~3s until it reaches a terminal
// state.
export const RESULT_PDF_POLL_INTERVAL_MS = 3000

// Generous cap on the whole poll loop: the backend issue behind this endpoint calls for testing with
// files at least 100-200 MB, and a build that size can run well past a typical request's timeout. A
// build still running past this is reported as "taking too long" rather than polled forever.
export const RESULT_PDF_POLL_TIMEOUT_MS = 10 * 60 * 1000
